module.exports = __webpack_public_path__ + "media/images/pc/components/specials/special_offer/arrow-e219ee6861f412118f171384e0d805a5.svg";